<template>
  <div class="dialogPc">
    <div class="box" >
      <img class="bg" src="../../../assets/image/about/Q_a_bg.jpg" />
      <img class="cancel" src="../../../assets/image/about/ic-cancel.png" @click="cancel" />
      <div class="title">
        {{ data?.name }}
      </div>
      <div class="content">
        <div v-html="data?.contentweb"></div>
      </div>
    </div>
  </div>

  <div class="dialogMobile">
    <div class="box">
      <img class="bg" src="../../../assets/image/about/Q_a_bg.jpg" />
      <img class="cancel" src="../../../assets/image/about/ic-cancel.png" @click="cancel" />
      <div class="title">
        {{ data?.name }}
      </div>
      <app-richtext class="content" :value="data?.contentmobile"></app-richtext>
<!--      
      <div class="content">

        <div v-html="data?.contentmobile"></div>
      </div> -->
    </div>
  </div>

</template>

<script>
import AppRichtext from '@/components/app-richtext/index.vue';

export default {

  components: { AppRichtext },
  props: { data: Object },
  data() {
    return {};
  },

  computed: {},
  created() { },
  mounted() { 
    // document.body.style.overflow = 'hidden'
  },
  methods: {
    cancel() {

      this.$emit('cancel');
    }
  },
};
</script>
<style lang="scss" scoped>


@media screen and (min-width: 1200px) {

  .dialogMobile {
    display: none;
  }

  .dialogPc {
    overflow: hidden ;
    width: 100vw;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.8);

    display: flex;
    justify-content: center;
    align-items: center;

    .box {
      position: relative;
      width: 900px;
      height: 600px;
      background: #FFFFFF;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .cancel {
        cursor: pointer;
        z-index: 99;
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
      }

      .bg {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 394px;
        height: 325px;
        border-radius: 0 0  10px 0;

      }

      .title {
        margin-top: 30px;
        color: color.$base;
        font-weight: bold;
        font-size: 30px;

      }

      .content {
        margin-top: 30px;
        position: relative;
        z-index: 99;
        width: 100%;
        height: 500px;
        box-sizing: border-box;
        padding: 30px;
        @include fn.scroll;
        overflow-y: scroll;
        overflow-x: hidden;

      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
  .dialogPC {
    display: none;
  }

  .dialogMobile {
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.8);

    display: flex;
    justify-content: center;
    align-items: center;

    .box {
      position: relative;
      width: 90%;
      height: fn.rpx(800);
      background: #FFFFFF;
      border-radius:fn.rpx( 10);
      display: flex;
      flex-direction: column;
      align-items: center;

      .cancel {
        cursor: pointer;
        z-index: 99;
        position: absolute;
        top: fn.rpx(20);
        right: fn.rpx(20);
        width: fn.rpx(40);
        height: fn.rpx(40);
      }

      .bg {
        position: absolute;
        bottom: 0;
        right: 0;
        width: fn.rpx(196);
        height: fn.rpx(162);
        border-radius: 0 0  fn.rpx(10) 0;

      }

      .title {
        margin-top: fn.rpx(30);
        color: color.$base;
        font-weight: bold;
        font-size: fn.rpx(30);

      }

      .content {
        margin-top: fn.rpx(30);
        z-index: 99;
        width: 100%;
        // overflow: hidden;
        height: fn.rpx(640);
        box-sizing: border-box;
        padding: fn.rpx(20) fn.rpx(10) fn.rpx(20) fn.rpx(40);
        // @include fn.scroll;
        // overflow-y: scroll;
        // overflow-x: hidden;
      }
    }
  }
}
</style>